import React from 'react';
import { InvoiceProps } from '../models/InvoiceProps';
import InvoiceAmount from './InvoiceAmount';
import InvoiceInfo from './InvoiceInfo';

const GuestInvoiceContent: React.FunctionComponent<InvoiceProps> = (props) => {
    const { invoice } = props;

    return (
      <>
        <InvoiceInfo invoice={invoice} />

        <InvoiceAmount invoice={invoice}/>
      </>
    )
}

export default GuestInvoiceContent;